import React, { useState, useEffect, useRef } from "react";
import "../style/subscribe.scss";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import { useNavigate } from "react-router-dom";
import { routeToPage } from "../util/RouteToPage";
import PagePath from "../util/RoutePagePath";
import { useDispatch } from "react-redux";
import { addItem } from "../store/cartSlice";

const Subscription = () => {
  const [selectedPlan, setSelectPlan] = useState(null);
  const navigate = useNavigate();
  const isFirstRender = useRef(true);
  const dispatch = useDispatch();

  const plans = [
    {
      id: 5001,
      title: "Essential Clothing Plan",
      flag: "plan",
      price: 79,
      total: 79,
      image: [],
      quantity: 1,
      description:
        "Get stylish tops and casual clothing essentials each season — perfect for work and daily wear.",
      features: [
        "👕 Seasonal tops and T-shirts",
        "🧥 Lightweight outerwear or sweaters",
        "✨ Versatile daily outfits",
      ],
    },
    {
      id: 5002,
      title: "Smart Pants & Denim Box",
      flag: "plan",
      price: 139,
      total: 139,
      image: [],
      quantity: 1,
      description:
        "Curated selection of pants and denim styles — stay sharp at work and comfortable in leisure.",
      features: [
        "👖 Classic chinos or formal trousers",
        "👖 Trendy jeans and seasonal pants",
        "🔗 Easy-to-match style suggestions",
      ],
    },
    {
      id: 5003,
      title: "Shoes & Accessories Pack",
      flag: "plan",
      price: 199,
      total: 199,
      image: [],
      quantity: 1,
      description:
        "Refresh your footwear collection with fashionable shoes and matching accessories every season.",
      features: [
        "👟 Casual sneakers or loafers",
        "👠 Seasonal formal or casual shoes",
        "🧦 Matching socks or belt accessories",
      ],
    },
  ];

  const handlePlanSelection = (plan) => {
    setSelectPlan(plan);
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (selectedPlan) {
      dispatch(addItem(selectedPlan));
      routeToPage(navigate, PagePath.CHECKOUT_PAGE);
    }
  }, [selectedPlan]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="subscription-container">
        <h2 className="title">Choose Your Fashion Subscription Plan</h2>
        <p className="subtitle">
          Seasonal curated fashion collections — from everyday clothing and
          pants, to stylish shoes or luxury bags. Refresh your wardrobe with
          confidence every season.
        </p>
        <div className="plans">
          {plans.map((plan) => (
            <div key={plan.id} className="plan">
              <h3>{plan.title}</h3>
              <p className="price">{plan.price} USD / season</p>
              <p>{plan.description}</p>
              <ul className="features">
                {plan.features.map((f, i) => (
                  <li key={i}>{f}</li>
                ))}
              </ul>
              <button
                className="subscribe-btn"
                onClick={() => handlePlanSelection(plan)}
              >
                Subscribe Now
              </button>
            </div>
          ))}
        </div>
        <p className="note">Cancel anytime. No hidden fees.</p>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Subscription;
